// local components
import AuthorLabel from './components/AuthorLabel';
import Container from './components/Container';
import MessageDate from './components/Date';
import FileContent from './components/FileContent';
import FileExpiry from './components/FileExpiry';
import Message from './components/Message';
import MessageBody from './components/MessageBody';
import MessageRow from './components/MessageRow';
import Status from './components/Status';
import StatusRow from './components/StatusRow';
import SystemMessage from './components/SystemMessage';

// lib
import formatChatMessage from '../../lib/formatChatMessage.lib.chaya';
import getLocalTimeZoneAbbreviation from '../../lib/getLocalTimeZoneAbbreviation.lib.chaya';
import highlightChatMessage from '../../lib/highlightChatMessage.lib.chaya';

// propTypes
import PropTypes from 'prop-types';

// react
import React from 'react';

// types
import dateTimeType from '@drivesally/sally-fw/lib/type/types/dateTime.type';

const AUTHOR_LABELS = {
  bot: 'Sally',
  agent: 'Customer Service Representative',
};

const formatMessageDate = (date) =>
  `${dateTimeType(date).format()} ${getLocalTimeZoneAbbreviation(date)}`.trim();

const ReadReceipt = ({driverReadAt}) => {
  if (!driverReadAt) return null;
  return (
    <StatusRow>
      <Status>{`Read ${formatMessageDate(driverReadAt)}`}</Status>
    </StatusRow>
  );
};

const ChatMessage = ({agent, author, date, driverReadAt, message, type, highlight}) => {
  if (author === 'system') {
    return (
      <Container>
        <SystemMessage>
          <MessageBody
            dangerouslySetInnerHTML={{
              __html: highlightChatMessage(formatChatMessage(message), highlight),
            }}
          />
        </SystemMessage>
      </Container>
    );
  }

  if (type === 'file') {
    let fileData = {};
    try {
      fileData = JSON.parse(message);
    } catch (e) {}
    const {url = '#', name = 'File', mime_type: mimeType = '', ttl} = fileData;
    const isImage = mimeType.startsWith('image/');
    const isReply = author === 'bot' || author === 'agent';
    const label = agent || AUTHOR_LABELS[author];

    return (
      <Container>
        <MessageRow isReply={isReply}>
          <Message isReply={isReply}>
            {label && <AuthorLabel>{label}</AuthorLabel>}
            <FileContent>
              {isImage && (
                <a href={url} target="_blank" rel="noopener noreferrer">
                  <img src={url} alt={name} />
                </a>
              )}
              <a href={url} target="_blank" rel="noopener noreferrer">
                <span role="img" aria-label="attachment">
                  📎
                </span>{' '}
                {name}
              </a>
              {ttl != null && (
                <FileExpiry>
                  {`Link expires ${new window.Date(ttl * 1000).toLocaleString()}`}
                </FileExpiry>
              )}
            </FileContent>
            <MessageDate>{formatMessageDate(date)}</MessageDate>
          </Message>
        </MessageRow>
        {isReply && <ReadReceipt driverReadAt={driverReadAt} />}
      </Container>
    );
  }

  if (type && type !== 'txt') {
    return (
      <Container>
        <SystemMessage>{`Unknown chat type: ${type}`}</SystemMessage>
      </Container>
    );
  }

  const isReply = author === 'bot' || author === 'agent';
  const label = agent || AUTHOR_LABELS[author];

  return (
    <Container>
      <MessageRow isReply={isReply}>
        <Message isReply={isReply}>
          {label && <AuthorLabel>{label}</AuthorLabel>}
          <MessageBody
            dangerouslySetInnerHTML={{
              __html: highlightChatMessage(formatChatMessage(message), highlight),
            }}
          />
          <MessageDate>{formatMessageDate(date)}</MessageDate>
        </Message>
      </MessageRow>
      {isReply && <ReadReceipt driverReadAt={driverReadAt} />}
    </Container>
  );
};

ChatMessage.propTypes = {
  agent: PropTypes.string,
  author: PropTypes.string,
  date: PropTypes.string,
  driverReadAt: PropTypes.string,
  error: PropTypes.bool,
  highlight: PropTypes.string,
  message: PropTypes.string,
  messageId: PropTypes.number,
  onDelete: PropTypes.func,
  onRetry: PropTypes.func,
  sending: PropTypes.bool,
  type: PropTypes.string,
};

export default ChatMessage;
